module.exports = __webpack_public_path__ + "static/media/img_cta.260150b7.png";